import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { mangaWorks } from "@/mocks/manga";

export default function LatestUpdates() {
  const list = mangaWorks.slice(0, 9);

  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          title="最新更新"
          subtitle="连载作品每日准时上架，第一时间追更热门漫画"
          moreLink="/category/all"
          moreText="更新"
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((work) => (
            <Link
              key={work.id}
              to={`/manga/${work.id}`}
              title={`${work.title}漫画免费阅读`}
              className="group flex items-center gap-3.5 rounded-lg border border-background-200/70 bg-background-100 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300/60"
            >
              <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={work.cover}
                  alt={`${work.title}漫画封面`}
                  title={`${work.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {work.title}
                </h3>
                <p className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-600">
                  <span className="whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 text-[11px] font-bold text-accent-700">
                    更新
                  </span>
                  <span className="truncate">{work.latestChapter}</span>
                </p>
                <p className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span>{work.categoryName}</span>
                  <span>{work.updateTime}</span>
                </p>
              </div>
              <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-400 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}